import React from 'react';
import LayoutDashboardIcon from '../../assets/icons/ic-layout-dashboard.svg?react';
import LineChartIcon from '../../assets/icons/ic-line-chart.svg?react';
import LayersIcon from '../../assets/icons/ic-layers.svg?react';
import AlertIcon from '../../assets/icons/ic-alert.svg?react';
import SettingsIcon from '../../assets/icons/ic-settings.svg?react';
import FlagIcon from '../../assets/icons/ic-flag.svg?react';
import FileCheckIcon from '../../assets/icons/ic-file-check.svg?react';
import GitCompareIcon from '../../assets/icons/ic-git-compare.svg?react';
import ListChecksIcon from '../../assets/icons/ic-list-checks.svg?react';
import Settings2Icon from '../../assets/icons/ic-settings2.svg?react';
import LogOutIcon from '../../assets/icons/ic-log-out.svg?react';

interface IconWrapperProps {
  className?: string;
}

const IconWrapper: React.FC<{ children: React.ReactNode; className?: string }> = ({ children, className }) => (
  <span className={className} style={{ display: 'inline-flex', alignItems: 'center', justifyContent: 'center' }}>
    {children}
  </span>
);

export const DashboardIcon: React.FC<IconWrapperProps> = ({ className }) => (
  <IconWrapper className={className}>
    <LayoutDashboardIcon />
  </IconWrapper>
);

export const FinancialIcon: React.FC<IconWrapperProps> = ({ className }) => (
  <IconWrapper className={className}>
    <LineChartIcon />
  </IconWrapper>
);

export const HierarchyIcon: React.FC<IconWrapperProps> = ({ className }) => (
  <IconWrapper className={className}>
    <LayersIcon />
  </IconWrapper>
);

export const RiskIcon: React.FC<IconWrapperProps> = ({ className }) => (
  <IconWrapper className={className}>
    <AlertIcon />
  </IconWrapper>
);

export const ControlIcon: React.FC<IconWrapperProps> = ({ className }) => (
  <IconWrapper className={className}>
    <SettingsIcon />
  </IconWrapper>
);

export const GapIcon: React.FC<IconWrapperProps> = ({ className }) => (
  <IconWrapper className={className}>
    <FlagIcon />
  </IconWrapper>
);

export const CertificationIcon: React.FC<IconWrapperProps> = ({ className }) => (
  <IconWrapper className={className}>
    <FileCheckIcon />
  </IconWrapper>
);

export const COSOIcon: React.FC<IconWrapperProps> = ({ className }) => (
  <IconWrapper className={className}>
    <GitCompareIcon />
  </IconWrapper>
);

export const AuditIcon: React.FC<IconWrapperProps> = ({ className }) => (
  <IconWrapper className={className}>
    <ListChecksIcon />
  </IconWrapper>
);

export const SystemSettingsIcon: React.FC<IconWrapperProps> = ({ className }) => (
  <IconWrapper className={className}>
    <Settings2Icon />
  </IconWrapper>
);

export const LogoutIcon: React.FC<IconWrapperProps> = ({ className }) => (
  <IconWrapper className={className}>
    <LogOutIcon />
  </IconWrapper>
);

